'use client'

import { deleteCookie } from 'cookies-next/client'
import { type FC, useEffect } from 'react'
import { useIntl } from 'react-intl'

import { useActivateContentsquareExperiment } from 'contentsquare'

import { Experiment } from '../../experiments/components/Experiment'
import { ExperimentsPageTypeProvider } from '../../experiments/components/ExperimentsPageTypeContext'
import { ExperimentVariant } from '../../experiments/components/ExperimentVariant'
import { ExperimentPageType } from '../../experiments/ExperimentPageType'
import {
  EXPERIMENT_NAME_CONTACT_PAGE_REDESIGN,
  EXPERIMENT_NAME_DIRECT_CONTACT_FORM_DIALOG,
  EXPERIMENT_NAME_HELP_CENTER_SELF_SERVICES,
} from '../../experiments/model/EXPERIMENT_NAME'
import { EXPERIMENT_VARIATION } from '../../experiments/model/EXPERIMENT_VARIATION'
import { useGlobalConfigContext } from '../../global-config'
import { INVOICES_SECTION_KEY } from '../../order-question'
import { StandardShopLayout } from '../../standard-shop-layout'

import { ContactPageDirectContactInformationSection } from './ContactPageDirectContactInformationSection'
import { ContactPageDirectContactSection } from './ContactPageDirectContactSection'
import { contactPageGetFaqCards } from './ContactPageFaqCards'
import { ContactPageFaqCardsSection } from './ContactPageFaqCardsSection'
import { ContactPageLayout } from './ContactPageLayout'
import { ContactPageMetas } from './ContactPageMetas'
import { ContactPageOrdersSection } from './ContactPageOrdersSection'
import { type ContactPageProps } from './ContactPageProps'

export const ContactPage: FC<ContactPageProps> = ({ standardLayoutData }) => {
  useActivateContentsquareExperiment(EXPERIMENT_NAME_CONTACT_PAGE_REDESIGN)
  useActivateContentsquareExperiment(EXPERIMENT_NAME_HELP_CENTER_SELF_SERVICES)

  useEffect(() => {
    deleteCookie(INVOICES_SECTION_KEY)
  }, [])

  const intl = useIntl()
  const config = useGlobalConfigContext()

  return (
    <ExperimentsPageTypeProvider pageType={ExperimentPageType.Contact}>
      <StandardShopLayout standardLayoutData={standardLayoutData}>
        <ContactPageMetas />
        <ContactPageLayout>
          <ContactPageOrdersSection />
          <ContactPageFaqCardsSection
            cards={contactPageGetFaqCards(config, intl)}
          />
          <Experiment names={[EXPERIMENT_NAME_DIRECT_CONTACT_FORM_DIALOG]}>
            <ExperimentVariant name={EXPERIMENT_VARIATION.DEFAULT}>
              <ContactPageDirectContactSection />
            </ExperimentVariant>
            <ExperimentVariant name={EXPERIMENT_VARIATION.V1}>
              <ContactPageDirectContactInformationSection />
            </ExperimentVariant>
          </Experiment>
        </ContactPageLayout>
      </StandardShopLayout>
    </ExperimentsPageTypeProvider>
  )
}
